import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { login, getToken } from "@/lib/adminApi";
import { Lock, ArrowRight } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (getToken()) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1D1D1F] text-white flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <div className="font-serif-luxe text-4xl">
            DXB <span className="text-[#B68D40]">Property Zone</span>
          </div>
          <p className="eyebrow text-[#C9A469] mt-3">Admin Console</p>
        </div>

        <form onSubmit={submit} className="space-y-8 bg-white/5 border border-white/10 p-10" data-testid="admin-login-form">
          <div className="flex items-center gap-3 pb-4 border-b border-white/10">
            <Lock size={18} strokeWidth={1.3} className="text-[#B68D40]" />
            <div className="font-serif-luxe text-2xl">Sign In</div>
          </div>

          <div>
            <label className="text-[0.7rem] tracking-[0.16em] uppercase text-white/50">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-luxe on-dark"
              data-testid="admin-login-email"
            />
          </div>

          <div>
            <label className="text-[0.7rem] tracking-[0.16em] uppercase text-white/50">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-luxe on-dark"
              data-testid="admin-login-password"
            />
          </div>

          <button type="submit" disabled={loading} className="btn-luxe w-full" data-testid="admin-login-submit">
            {loading ? "Signing in…" : (<>Sign In <ArrowRight size={16} strokeWidth={1.4} /></>)}
          </button>
        </form>

        <p className="text-white/40 text-xs text-center mt-8">Restricted area · Authorized personnel only</p>
      </div>
    </div>
  );
}
